import React, { useState, useEffect, useRef } from 'react';
import className from 'classnames/bind';
import { connect } from 'react-redux';
import ReviewAllShimmer from '../../shimmers/reviewAll.shimmer';
import Modal from '../../../components/common/Modal';
import CustomerPhotoGridModal from './ReviewCustomerPhotoGridModal/CustomerPhotoGridModal';
import ReviewSinglePhotoModal from './ReviewSinglePhotoModal/ReviewSinglePhotoModal';
import { getAllReviews } from '../../../actions/ratings';
import ReviewDetails from './ReviewDetails';
import RatingCard from '../../atoms/RatingCard';
import RateCalculationPopup from '../RateCalculationPopup';
import CustomerOpinion from '../../atoms/CustomerOpinion';
import { SortByReviews } from './constants';
import properties from '../../../modules/ajio-util/properties';
import { gtmEventPush } from '../../../modules/ga/GTMdatalayer';
import styles from './index.pcss';
import { replaceWithJioCDN } from '../../../utils/imageHandling';

const cx = className.bind(styles);
const ViewAllReviewsDesktop = (props: any) => {
  const {
    totalRatingCount,
    totalStarCount,
    isProgressBar,
    rateData,
    customerWords,
    imageReview,
    subRating,
    titleD,
    productCode,
    productName,
    product_id,
    product_brick,
    aggregateRating,
    images,
    showModal,
    hideModal,
    productData = {}
  } = props;
  // const dodPriceSectionClass = isDealStart && !isDealEnd ? "dod-price-section" : ""
  const { brandName = '', name = '' } = productData;
  const pageSize = 20;
  const [textReviews, setTextReview] = useState([]);
  const [viewPhotoReviews, setPhotoReviews] = useState([]);
  const [loading, setLoading] = useState(false);
  const [textLoading, setTextLoading] = useState(false);
  const [apiCalled, setApiCalled] = useState(false);
  const targetRef = useRef(null);
  const { getAllReviews } = props;
  const photosArrayToShow =
    imageReview?.totalReviews > 5
      ? imageReview?.productReviewImages.slice(0, 5)
      : imageReview?.productReviewImages;
  const textNumberOnPhotos = (imageReview?.totalReviews > 5 && imageReview?.totalReviews - 5) || 0;
  const [filters, setFilters] = useState({
    reviewWithPhotos: false,
    verifiedPurchase: false,
    sortBy: SortByReviews[0].value
  });
  const [rating, setRating] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [photoPageNumber, setphotoPageNumber] = useState(1);
  const [showRateCalculation, setShowRateCalculation] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(SortByReviews[0]);

  const productDetails = {
    productId: product_id ?? '',
    productName: productName ?? '',
    productBrick: product_brick ?? ''
  };

  const calculatePopup = () => {
    setShowRateCalculation(!showRateCalculation);
  };

  function handleToggle() {
    setIsOpen(!isOpen);
  }

  let body = document.body;

  body.addEventListener('click', function() {
    if (isOpen) {
      setIsOpen(!isOpen);
    }
  });

  function handleOptionSelect(option) {
    setSelectedOption(option);
    setIsOpen(false);
    setFilters(prevFilters => ({
      ...prevFilters,
      sortBy: option.value
    }));
  }

  const handleRatingChange = event => {
    const value = parseInt(event.target.value);
    const checked = event.target.checked;
    if (checked) {
      setRating([...rating, value]);
    } else {
      setRating(rating.filter(item => item !== value));
    }
  };

  const handleFilterChange = (event: any) => {
    const { name, type, value, checked } = event.target;
    setFilters(prevFilters => ({
      ...prevFilters,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  useEffect(() => {
    // add event listener to the window object to prevent scrolling of the page behind the modal
    const body = document.body;
    const scrollY = window.scrollY;
    body.style.position = 'fixed';
    body.style.top = `-${scrollY}px`;
    body.style.width = '100%';

    // remove event listener when the modal is closed
    return () => {
      body.style.position = '';
      body.style.top = '';
      body.style.width = '';
      window.scrollTo(0, scrollY);
    };
  }, []);

  useEffect(() => {
    const reqObj = {
      ...filters,
      rating,
      pageNumber: 1,
      pageSize,
      skuId: product_id
    };
    setTextReview([]);
    fetchData(reqObj);
  }, [filters, rating]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        const target = entries[0];
        if (target.isIntersecting && !apiCalled) {
          callApi();
          setApiCalled(true);
        } else if (!target.isIntersecting && apiCalled) {
          setApiCalled(false);
        }
      },
      { threshold: 0.7 }
    );

    observer.observe(targetRef.current);

    // cleanup function to disconnect the observer
    return () => {
      observer.disconnect();
    };
  }, [targetRef, apiCalled]);

  const callApi = () => {
    // make API call here
    let pageNum = pageNumber;
    if (textReviews && textReviews.length !== 0) {
      pageNum = pageNumber + 1;
    }
    const apiFilters = {
      ...filters,
      pageNumber: pageNum,
      pageSize,
      skuId: product_id
    };
    if (
      textReviews &&
      textReviews.length > 0 &&
      textReviews.length % pageSize === 0 &&
      !textLoading
    ) {
      fetchData(apiFilters);
    }
  };

  const fetchData = async filters => {
    try {
      if (!textLoading) {
        setTextLoading(true);
        const newData = await getAllReviews(filters);
        const { productReviews } = newData.reviewData;
        if (productReviews && productReviews.length > 0 && productReviews.length === pageSize) {
          setPageNumber(pageNumber + 1);
        }
        if (productReviews && productReviews.length > 0) {
          setTextReview(prevData => [...prevData, ...productReviews]);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setTextLoading(false);
    }
  };

  const fetchPhotoData = async pageNum => {
    try {
      const filters = {
        rating: [],
        reviewWithPhotos: true,
        verifiedPurchase: false,
        sortBy: SortByReviews[0].value,
        pageNumber: pageNum,
        skuId: product_id
      };
      setLoading(true);
      const newData = await getAllReviews(filters);
      const { productReviews } = newData.reviewData;
      if (productReviews && productReviews.length > 0 && productReviews.length === pageSize) {
        setphotoPageNumber(pageNum);
      }
      setPhotoReviews(prevData => [...prevData, ...productReviews]);
    } catch (error) {
      console.error(error);
      hideModal('reviews-customer-photos-grid-all');
    } finally {
      setLoading(false);
    }
  };

  const clickMorePhotos = () => {
    setPhotoReviews([]);
    fetchPhotoData(1);
    showModal('reviews-customer-photos-grid-all');
    gtmEventPush({
      event: 'reviews_rating_interactions',
      event_category: 'reviews_rating_interactions',
      event_action: 'customer photos',
      event_label: 'clicked',
      ...(product_id.length > 0 && { product_id }),
      ...(product_brick.length > 0 && { product_brick }),
      ...(productName.length > 0 && { product_name: productName }),
      pageType: 'PDP',
      store_type: 'ajio'
    });
  };

  const renderSinglePhotoModal = (elObj, i) => {
    showModal('reviews-single-photo', {
      state: {
        reviewsCollection: [],
        reviewData: elObj,
        loop: true,
        arrowEnabled: false,
        clickIndex: i
      }
    });
  };

  return (
    <div className={cx('modal')}>
      <button className={cx('back-btn')} onClick={props.closeModal}>
        <img
          alt="Back arrow"
          className={cx('backIcon-modal')}
          src={`${properties.getProperty('imageBaseUrl')}/static/img/back-arrow-refresh.svg`}
        />
      </button>
      <div className={cx('modal-content')}>
        <div className={cx('rating-card-withReviewAll')}>
          <div className={cx('rating-card')}>
            <RatingCard
              totalRatingCount={totalRatingCount}
              totalStarCount={totalStarCount}
              isProgressBar={isProgressBar}
              rateData={rateData}
              isDesktop
              calculatePopup={calculatePopup}
              customerWords={customerWords}
              productData={productData}
            />
          </div>
          <hr />
          {customerWords && customerWords.length !== 0 ? (
            <>
              <CustomerOpinion
                noReviews
                subRating={subRating}
                titleD={titleD}
                isDesktop
                customerWords={customerWords}
                productCode={productCode}
                productName={productName}
                product_id={product_id}
                product_brick={product_brick}
                aggregateRating={aggregateRating}
                fromViewAllDesktop
              />
            </>
          ) : null}
        </div>
        <div className={cx('photo-all-review')}>
          <div className={cx('primary-image')}>
            <img
              ref={scaledImage => {
                scaledImage = scaledImage;
              }}
              className={cx('reviews-section-img-web')}
              src={`${replaceWithJioCDN(images.url)}`}
              alt="Customer review image"
            />
            <h2 className={cx('brand-name')}>{brandName}</h2>
            <h1 className={cx('prod-name')}>{name}</h1>
            {/* <div className={`prod-price-section ${dodPriceSectionClass}`}>
          { !isDealStart && isDealEnd ? !productData.potentialPromotions 
            ?
            <span className="prod-sp best-price-strip">{displayValueWithSymbol(this.props.discountPrice)}</span>
            :
            <div className="prod-sp">
              {
                (this.props.originalPrice === this.props.discountPrice) && hideMRP && 
                <span className="prod-mrp">{SHOW_MRP_TEXT}</span>
              }
              {displayValueWithSymbol(finalPriceAfterDiscount)}
            </div>
            : 
            isDealStart && !isDealEnd && this.state.showClaim ? 
            !productData.potentialPromotions  ? <span className="prod-sp best-price-strip">{this.props.discountPrice}</span>
            : <div className="prod-sp">{displayValueWithSymbol(finalPriceAfterDiscount)}</div>
            : null
          }
          { ( !isDealStart && isDealEnd && this.props.originalPrice !== this.props.discountPrice) && hideMRP?
            ( <div className="prod-price-sec">
                <span className="prod-mrp">{SHOW_MRP_TEXT}</span>
                <span className="prod-cp">{displayValueWithSymbol(this.props.originalPrice)}</span>
                {parseInt(this.props.discountPercentage) > 0 && <span className="prod-discnt">&nbsp;({this.props.discountPercentage})</span>}
              </div> )
              :
              isDealStart && !isDealEnd && this.state.showClaim && this.props.originalPrice !== this.props.discountPrice && hideMRP ?
              (<div className="prod-price-sec">
                <span className="prod-mrp">{SHOW_MRP_TEXT}</span>
                <span className="prod-cp">{displayValueWithSymbol(this.props.originalPrice)}</span>
                {parseInt(this.props.discountPercentage) > 0 && <span className="prod-discnt">&nbsp;({this.props.discountPercentage})</span>}
              </div> )
              : null
            
          }
          {oldPriceList}
          {priceSectionDom}
        </div> */}
          </div>
          <div className={cx('view-all-review-desktop')}>
            {imageReview?.totalReviews > 0 && (
              <div className={cx('reviews-photos-section-web')}>
                <span className={cx('reviews-section-title-web')}>
                  <strong>Customer Photos</strong>
                </span>
                <div className={cx('reviews-section-customer-photos')}>
                  {photosArrayToShow.length > 0 &&
                    photosArrayToShow.map((el1, i) => {
                      const imageUrlContent = el1?.imageMap?.thumbnail;
                      const imgUrl = imageUrlContent?.length > 0 && imageUrlContent[0].imageUrl;
                      if (textNumberOnPhotos > 0 && i === 4) {
                        return (
                          <div
                            className={cx('reviews-section-image-web')}
                            onClick={clickMorePhotos}
                          >
                            <img
                              className={cx('reviews-section-img-web', 'blur-bg')}
                              src={`${replaceWithJioCDN(imgUrl)}`}
                              alt="Customer review image"
                            />
                            <div className={cx('reviews-section-textimage-web')}>
                              + {textNumberOnPhotos}
                            </div>
                          </div>
                        );
                      }
                      return (
                        <div className={cx('reviews-section-image-web')} onClick={clickMorePhotos}>
                          <img
                            className={cx('reviews-section-img-web')}
                            src={`${replaceWithJioCDN(imgUrl)}`}
                            alt="Customer review image"
                          />
                        </div>
                      );
                    })}
                </div>
              </div>
            )}
            <div className={cx('header-sort')}>
              <span className={cx('heading')}>All Reviews</span>
              <span className={cx('sort-by-select')}>
                <label htmlFor="sortBy">Sort By : </label>
                <div className={cx('custom-dropdown', { open: isOpen })}>
                  <div className={cx('dropdown-toggle')} onClick={handleToggle}>
                    {selectedOption ? selectedOption.name : 'Select an option'}
                  </div>
                  <div className={cx('dropdown-menu')}>
                    {SortByReviews.map(option => (
                      <div
                        key={option.value}
                        className={cx('dropdown-item', {
                          active: selectedOption?.value === option.value
                        })}
                        onClick={() => handleOptionSelect(option)}
                      >
                        {option.name}
                      </div>
                    ))}
                  </div>
                </div>
              </span>
            </div>
            <div className={cx('filters')}>
              <span className={cx('heading')}>Filter By</span>
              <div className={cx('star-rating')}>
                {[...Array(5)].reverse().map((_, index) => (
                  <a
                    onClick={() => {
                      const ratingValue = 5 - index;
                      if (rating.includes(ratingValue)) {
                        setRating(rating.filter(value => value !== ratingValue));
                      } else {
                        setRating([...rating, ratingValue]);
                      }
                    }}
                    className={
                      rating.includes(5 - index) ? cx('star-box-checkedStar') : cx('star-box')
                    }
                  >
                    <label key={index}>
                      {' '}
                      {5 - index}
                      <input
                        type="checkbox"
                        name="rating"
                        value={5 - index}
                        checked={rating.includes(5 - index)}
                      />
                    </label>
                    <span className={cx('star-icon')}>
                      <img
                        alt="Star selected"
                        className={cx('star-icon-img')}
                        src={`${properties.getProperty('imageBaseUrl')}/static/img/starRating.svg`}
                      />
                    </span>
                  </a>
                ))}
              </div>
              <div className={cx('filters-review-checkbox')}>
                <label className={cx('review-label')} key="review-with-photos">
                  <input
                    type="checkbox"
                    name="reviewWithPhotos"
                    id="reviewWithPhotos"
                    checked={filters.reviewWithPhotos}
                    style={{ display: 'none' }}
                    onChange={handleFilterChange}
                  />
                  <img
                    alt={filters.reviewWithPhotos ? 'Checkbox selected' : 'Checkbox unselected'}
                    style={{ marginRight: '12px' }}
                    src={`${properties.getProperty('imageBaseUrl')}/static/img/${
                      filters.reviewWithPhotos ? 'checkedBox.svg' : 'unCheckedBox.svg'
                    }`}
                  />
                  Reviews with photos
                </label>
              </div>
              <div className={cx('filters-review-checkbox')}>
                <label className={cx('review-label')} key="verified-purchase">
                  <input
                    type="checkbox"
                    name="verifiedPurchase"
                    checked={filters.verifiedPurchase}
                    style={{ display: 'none' }}
                    onChange={handleFilterChange}
                  />
                  <img
                    alt={filters.verifiedPurchase ? 'Checkbox selected' : 'Checkbox unselected'}
                    style={{ marginRight: '12px' }}
                    src={`${properties.getProperty('imageBaseUrl')}/static/img/${
                      filters.verifiedPurchase ? 'checkedBox.svg' : 'unCheckedBox.svg'
                    }`}
                  />
                  Verified purchase
                </label>
              </div>
            </div>
            <div ref={targetRef} className={cx('review-box')}>
              <div>
                {textReviews?.length > 0 &&
                  textReviews.map(el => {
                    return (
                      <ReviewDetails
                        key={el.id}
                        isDesktop
                        reviewData={el}
                        renderSinglePhotoModal={renderSinglePhotoModal}
                        productDetails={productDetails}
                      />
                    );
                  })}
                {!textLoading && textReviews.length === 0 && (
                  <span className={cx('no-reviews')}>
                    No reviews to display for the filters applied
                  </span>
                )}
              </div>
              {textLoading && <ReviewAllShimmer />}
            </div>
          </div>
        </div>
      </div>
      <Modal
        name="reviews-customer-photos-grid-all"
        className="reviews-customer-photos-grid"
        id="reviewsCustomerPhotosGrid"
        closeButton
        disableOutsideClick
        onClose={() => {
          hideModal('reviews-customer-photos-grid-all');
        }}
      >
        <CustomerPhotoGridModal
          fetchData={fetchPhotoData}
          loading={loading}
          viewPhotoReviews={viewPhotoReviews}
          pageNumber={photoPageNumber}
          app="DESKTOP"
        />
      </Modal>
      <Modal
        name="reviews-single-photo"
        className="reviews-single-photo"
        id="reviewsSinglePhoto"
        closeButton
        disableOutsideClick
        onClose={() => {
          gtmEventPush({
            event: 'reviews_rating_interactions',
            event_category: 'reviews_rating_interactions',
            event_action: 'photo interaction',
            event_label: 'cross',
            ...(product_id.length > 0 && { product_id }),
            ...(productName.length > 0 && { product_name: productName }),
            ...(product_brick.length > 0 && { product_brick }),
            pageType: 'PDP',
            store_type: 'ajio'
          });
          hideModal('reviews-single-photo');
        }}
      >
        <ReviewSinglePhotoModal app="DESKTOP" />
      </Modal>
      {showRateCalculation && <RateCalculationPopup visible isDesktop />}
    </div>
  );
};

const mapDispatchToProps = dispatch => {
  return {
    getAllReviews: (reqObj = {}) => dispatch(getAllReviews(reqObj))
  };
};
const mapStateToProps = state => ({});
const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(ViewAllReviewsDesktop);
